export const PARTNER_ORG_HANDLED_BY_VALUES = [
  "CALL_CENTER",
  "COORDINATORS",
] as const;

export type PartnerOrgHandledBy = (typeof PARTNER_ORG_HANDLED_BY_VALUES)[number];

export const PARTNER_ORG_HANDLED_BY_OPTIONS: {
  value: PartnerOrgHandledBy;
  label: string;
}[] = [
  { value: "CALL_CENTER", label: "מוקד" },
  { value: "COORDINATORS", label: "רכזות" },
];

export function partnerOrgHandledByLabel(
  value: string | null | undefined,
): string {
  return (
    PARTNER_ORG_HANDLED_BY_OPTIONS.find((option) => option.value === value)
      ?.label ?? ""
  );
}
